exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".auto-dialer--23BQ2MuDQG4nV6EsqkbWl2 {\n  color: #25aece;\n  font-weight: bold;\n  text-decoration: none;\n  cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"autoDialerLink": "auto-dialer--23BQ2MuDQG4nV6EsqkbWl2",
	"autoDialerLink": "auto-dialer--23BQ2MuDQG4nV6EsqkbWl2"
};